import React from "react";

export const FAQ_TITLE_GENERAL = "general";
export const FAQ_TITLE_FINANCE = "finance";
export const FAQ_TITLE_TECHNICAL = "technical";
